import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import { AppState, useAppSelector } from "reducers/store"
import styled from "styled-components"
import UserNameEdit from "./components/UserNameEdit"
import IconEdit from "components/EvtKit/icons/IconEdit"
import { useCallback, useState } from "react"
import { UpdatePassword } from "./components/UpdatePassword"

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.theme.palette.gray_ice};
  margin-top: 48px;
  gap: 20px;
  overflow: hidden;
`

const Title = styled.div`
  display: flex;
`

const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1056px;
  width: 100%;
  gap: 40px;
  background-color: ${(props) => props.theme.palette.white};
  padding: 32px 24px;
  border-radius: 10px;
  box-shadow: 0px 2px 6px 0px #0000001a;
`

const UserData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`

const ContainerContent = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const ContentPassword = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ButtonEdit = styled.button`
  & svg {
    width: 16px;
    height: 16px;
  }
`

export const Profile = () => {
  const { isAgency, email } = useAppSelector((x: AppState) => x.user.userPersonalInfo.data)

  const accountType = isAgency ? "Agência" : "Super Admin"

  const [updatePassword, setUpdatePassword] = useState<boolean>(false)

  const handleOpenUpdatePassword = useCallback(() => {
    setUpdatePassword(true)
  }, [])

  const handleCloseUpdatePassword = useCallback(() => {
    setUpdatePassword(false)
  }, [])

  return (
    <Container>
      <Title>
        <Heading variant="h3">Meu perfil</Heading>
      </Title>
      {!updatePassword && (
        <UserContainer>
          <UserData>
            <ContainerContent>
              <Content>
                <UserNameEdit />
              </Content>
              <Content>
                <Heading variant="h6">E-mail</Heading>
                <BodyText size="semi-medium">{email}</BodyText>
              </Content>
              <Content>
                <Heading variant="h6">Tipo de conta</Heading>
                <BodyText size="semi-medium">{accountType}</BodyText>
              </Content>
            </ContainerContent>
            <Content>
              <Heading variant="h6">Senha</Heading>
              <ContentPassword>
                <BodyText size="semi-medium">******</BodyText>
                <ButtonEdit type="button" onClick={handleOpenUpdatePassword} data-testId="button-edit">
                  <IconEdit />
                </ButtonEdit>
              </ContentPassword>
            </Content>
          </UserData>
        </UserContainer>
      )}
      {updatePassword && <UpdatePassword onGoBack={handleCloseUpdatePassword} onSuccess={handleCloseUpdatePassword} />}
    </Container>
  )
}
